module.exports = __webpack_public_path__ + "static/D365-human-resource-management_1-0e7597607e3b248c04c8441001b261c4.png";